/**
 * @author czy
 * 功能：凭证模版
 */

import { Service } from '@/tools'

export class ProofTemplateService<T extends TSettle.ProofTemplate> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.ProofTemplate}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 分页查询凭证模版/api/settle/proofTemplate/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 凭证模板新增  /api/settle/proofTemplate/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  // 凭证模板启动 /api/settle/proofTemplate/v1/enableProofTemplate
  enableProofTemplate = <K extends T['ApiEnableProofTemplate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnableProofTemplate', data)

  // 凭证模板禁用 /api/settle/proofTemplate/v1/disableProofTemplate
  disableProofTemplate = <K extends T['ApiDisableProofTemplate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDisableProofTemplate', data)

  // 凭证模板删除 /api/settle/proofTemplate/v1/deleteById
  deleteById = <K extends T['ApiDeleteById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteById', data)

  // 查看模板详情 /api/settle/proofTemplate/v1/detail
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  // 编辑模板详情 /api/settle/proofTemplate/v1/update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  //列表查询凭证模版/api/settle/proofTemplate/v1/list
  list = <K extends T['ApiList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiList', data)
  //查询凭证模板去重后的记账类型/api/settle/proofTemplate/v1/findDistinctAccountingTypes
  findDistinctAccountingTypes = <K extends T['ApiFindDistinctAccountingTypes']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiFindDistinctAccountingTypes', data)
}
